import { render, staticRenderFns } from "./advanced.vue?vue&type=template&id=63485817&scoped=true&"
import script from "./advanced.vue?vue&type=script&lang=js&"
export * from "./advanced.vue?vue&type=script&lang=js&"
import style0 from "./advanced.vue?vue&type=style&index=0&id=63485817&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63485817",
  null
  
)

export default component.exports